import Helmet from 'preact-helmet';

const themeColor = require('./manifest').theme_color;

const HeadStuff = () => (
  <Helmet
    title="Godnat"
    link={[
      {
        rel: 'apple-touch-icon',
        sizes: '180x180',
        href: 'assets/icons/apple-touch-icon.png',
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '32x32',
        href: 'assets/icons/favicon-32x32.png',
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '16x16',
        href: 'assets/icons/favicon-16x16.png',
      },
      {
        rel: 'mask-icon',
        href: 'assets/icons/safari-pinned-tab.svg',
        color: themeColor,
      },
    ]}
    meta={[
      {
        name: 'description',
        content: 'A PWA for randomising a list of goodnight songs. Supports saving any number of songs for later. Swipe left to dismiss a song, swipe right to save for later.',
      },
      { name: 'msapplication-TileColor', content: '#2b5797' },
      {
        name: 'msapplication-config',
        content: 'browserconfig.xml',
      },
      { name: 'theme-color', content: themeColor },
    ]}
  />
);

export default HeadStuff;



// WEBPACK FOOTER //
// ./head-stuff.js